<h1>Vision Home</h1>

<div class="p-grid">
  <div class="p-col-12 p-md-6 p-lg-4 p-xl-3">
    <p-card header="Piece Rate" *ngIf="canSeePieceRate || canSeePieceRateAdmin">
      <ul>
        <li *ngIf="canSeePieceRate">
          <a href="/warehousing/#/piece-rate-form">Piece Rate Entry Form</a>
        </li>
        <li *ngIf="canSeePieceRateAdmin">
          <a href="/admin/#/piece-rate-weeks">Piece Rate Weeks</a>
        </li>
        <li *ngIf="canSeePieceRateAdmin">
          <a href="/admin/#/piece-rate-config">Piece Rate Configuration Form</a>
        </li>
      </ul>
    </p-card>
  </div>
</div>
